const adriverExtentionLoad = (a, b, containerId) => {
  const container = document.getElementById(containerId);
  if (a === 0 && container) container.style.height = '0';
  else container.style.height = '';
};

export default adriverExtentionLoad;
